module.exports = __webpack_public_path__ + "static/media/work-past-overtime-icon.cba2863e.svg";